import { Link } from "react-router-dom";
import { useApiData, fmtDate } from "@/lib/api";
import { FullLoader } from "@/components/common/ProtectedRoute";
import { StatusBadge } from "@/components/common/StatusBadge";
import { PageTitle, StatCard, EmptyState } from "@/components/shell/DashboardShell";

const MiniList = ({ title, to, rows, render, testid }) => (
  <div className="card-base p-6" data-testid={testid}>
    <div className="mb-4 flex items-center justify-between">
      <p className="font-semibold text-slate-900">{title}</p>
      <Link to={to} className="text-sm font-semibold text-[#C20500]" data-testid={`${testid}-view-all`}>View all</Link>
    </div>
    {rows.length ? <ul className="divide-y divide-slate-100">{rows.slice(0, 5).map(render)}</ul> : <p className="text-sm text-slate-400">Nothing here yet.</p>}
  </div>
);

export default function AdminOverview() {
  const { data: stats, loading } = useApiData("/admin/stats");
  const { data: pending } = useApiData("/admin/vendors?status=pending");
  const { data: enq } = useApiData("/admin/enquiries?status=new");
  if (loading) return <FullLoader />;
  if (!stats) return <EmptyState title="Unable to load stats" />;
  return (
    <div data-testid="admin-overview">
      <PageTitle eyebrow="Operations" title="Admin overview" text="Approvals, new enquiries and open portal requests at a glance." />
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <StatCard label="Pending approvals" value={stats.pending_vendors} icon="UserCheck" tone="amber" testid="admin-stat-pending" />
        <StatCard label="New enquiries" value={stats.new_enquiries} icon="Inbox" tone="red" testid="admin-stat-enquiries" />
        <StatCard label="Open requests" value={stats.open_requests} icon="Activity" testid="admin-stat-open-requests" />
        <StatCard label="Approved vendors" value={stats.approved_vendors} icon="Building2" testid="admin-stat-vendors" />
      </div>
      <div className="mt-8 grid gap-6 lg:grid-cols-2">
        <MiniList title="Awaiting approval" to="/admin/registrations" rows={pending || []} testid="admin-pending-list"
          render={(v) => (
            <li key={v.id} className="flex items-center justify-between gap-3 py-3">
              <div className="min-w-0"><p className="truncate text-sm font-medium text-slate-900">{v.company_name}</p><p className="truncate text-xs text-slate-500">{v.email} · {fmtDate(v.created_at)}</p></div>
              <StatusBadge status={v.status} />
            </li>
          )} />
        <MiniList title="New enquiries" to="/admin/enquiries" rows={enq || []} testid="admin-enquiry-list"
          render={(e) => (
            <li key={e.id} className="flex items-center justify-between gap-3 py-3">
              <div className="min-w-0"><p className="truncate text-sm font-medium text-slate-900">{e.company || e.name}</p><p className="truncate text-xs text-slate-500"><span className="mono">{e.reference}</span> · {e.kind.toUpperCase()} · {fmtDate(e.created_at)}</p></div>
              <StatusBadge status={e.status} />
            </li>
          )} />
      </div>
    </div>
  );
}
